import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';
import type { FC } from 'react';

import { ReactComponent } from './drop-app-icon.svg';

export const DropAppIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon component={ReactComponent} inheritViewBox {...props} />
);
